import {styled} from '@mui/material';

export const SubscriptionContainer = styled('div')(() => ({
  marginBottom: 30,
  '&:last-of-type': {
    marginBottom: 0,
  },
}));
